<template>
  <section>
    <notifications></notifications>
    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-6 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>

        <div
          class="col-lg-6 col-md-6 col-sm-6 col-6 align-items-center text-right"
        >
          <div class="box-buttons">
            <base-button
              type="primary"
              class="min-button"
              @click="goToNewReservation(productId, providerId)"
            >
              Book Now
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid  mb-5">
      <div class="row mb-5">
        <div class="col-12">
          <div class="details-products">
            <div class=" px-sm-1 px-0 border-top pt-3">
              <div class="products">
                <div class="row">
                  <div
                    class="col-xl-8 col-lg-7 col-md-12 col-sm-12 col-12 mb-4"
                  >
                    <div class="product-details">
                      <div class="card">
                        <h2 class="product-title">{{ product.title }}</h2>

                        <div class="mb-4">
                          <p
                            v-if="product.description"
                            v-html="product.description"
                            class="product-description"
                          ></p>

                          <p
                            v-else-if="product.shortDescription"
                            v-html="product.shortDescription"
                          ></p>

                          <p v-else>
                            An experience that will make you enjoy incredible
                            moments and create unforgettable memories,
                            transforming the way you see the world. Live
                            something unique!
                          </p>
                        </div>

                        <div class="mb-4" v-if="product.highlights.length">
                          <h2>Highlights</h2>
                          <ul class="highlights">
                            <li
                              v-for="(item, index) in product.highlights"
                              :value="item"
                              :label="item"
                              :key="index"
                            >
                              {{ item }}
                            </li>
                          </ul>
                        </div>

                        <div class="row">
                          <div
                            class="col-xl-6 col-lg-12 col-md-6 col-sm-6 col-12 box-flex"
                            v-if="product.inclusions.length"
                          >
                            <div class="mb-4">
                              <h2>What's Included</h2>
                              <div class="row">
                                <div
                                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 "
                                  v-for="(item, index) in product.inclusions"
                                  :value="item"
                                  :label="item"
                                  :key="index"
                                >
                                  <li class="inclusions">{{ item }}</li>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-xl-6 col-lg-12 col-md-6 col-sm-6 col-12 box-flex"
                            v-if="product.exclusions.length"
                          >
                            <div class="mb-4">
                              <h2>What's not Included</h2>
                              <div class="row">
                                <div
                                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                                  v-for="(item, index) in product.exclusions"
                                  :value="item"
                                  :label="item"
                                  :key="index"
                                >
                                  <li class="exclusions">{{ item }}</li>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div v-if="option && itinerary.length > 0" class="mb-4">
                          <h2>Itinerary</h2>

                          <div class="collapse-itinerary">
                            <collapse>
                              <collapse-item
                                type="show"
                                :name="index"
                                v-for="(point, index) in itinerary"
                                :key="index"
                                :title="point.name"
                                class="itinerary"
                                :class="{ start: point.type === 'START' }"
                              >
                                <div class="description-itinerary">
                                  <p
                                    class="mb-3"
                                    v-html="point.description"
                                  ></p>

                                  <div class="item">
                                    <i class="flaticon-pin"></i>
                                    <span
                                      ><strong>Address: </strong
                                      >{{ point.address }}</span
                                    >
                                  </div>

                                  <div class="item" v-if="point.travelTime">
                                    <span>
                                      <i class="flaticon-route"></i>
                                      <span
                                        ><strong>Travel Time: </strong
                                        >{{ point.travelTime }}</span
                                      >
                                    </span>
                                  </div>

                                  <div class="item" v-if="point.duration">
                                    <i class="flaticon-time"></i>
                                    <span
                                      ><strong>Duration: </strong
                                      >{{ point.duration }}</span
                                    >
                                  </div>
                                </div>
                              </collapse-item>
                            </collapse>
                          </div>
                        </div>
                        <div v-if="product.cancellationPolicy" class="mb-4">
                          <h2>Cancellation Policy</h2>
                          <p v-html="product.cancellationPolicy"></p>
                        </div>

                        <div v-if="product.faqs.length" class="mb-4">
                          <h2>FAQs</h2>

                          <ul class="list-faq">
                            <li
                              v-for="(point, index) in product.faqs"
                              :key="index"
                              class="mb-2"
                            >
                              <div class="d-flex align-items-center">
                                <i
                                  :class="{
                                    'flaticon-question': point.answer,
                                    'flaticon-check-3': !point.answer
                                  }"
                                  class="mr-2 d-inline-flex"
                                ></i>
                                <p
                                  :class="{
                                    'font-weight-bold': point.answer
                                  }"
                                  v-html="point.question"
                                ></p>
                              </div>

                              <p class="ml-4" v-html="point.answer"></p>
                            </li>
                          </ul>
                        </div>

                        <div v-if="product.bookingTerms">
                          <div v-if="product.bookingTerms.length > 2000">
                            <collapse>
                              <collapse-item
                                type="show"
                                name="terms"
                                key="0"
                                title="Terms"
                                class="terms"
                              >
                                <p v-html="product.bookingTerms"></p>
                              </collapse-item>
                            </collapse>
                          </div>

                          <div v-else>
                            <h2>Terms</h2>

                            <div
                              class="terms"
                              v-html="product.bookingTerms"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-xl-4 col-lg-5 col-md-12 col-sm-12 col-12 mb-3 products"
                  >
                    <div class="card content-price pt-3 pb-4" v-if="pricing">
                      <span class="amount-price"
                        >From
                        <strong class="price">
                          {{
                            getCurrenSymbolByCurrency(product.defaultCurrency)
                          }}
                          {{
                            getPriceByCurrencyPrecision(
                              pricing.retail,
                              pricing.currencyPrecision
                            )
                          }}
                          {{ product.defaultCurrency }}
                        </strong>
                      </span>
                      <span class="info-price">Price varies by Pax</span>
                    </div>
                    <div class="row">
                      <div
                        class="col-xl-12 col-lg-12 col-md-6 col-sm-12 col-12 mb-lg-0 mb-sm-4"
                      >
                        <div class="image-slide" v-if="gallery.length > 0">
                          <b-carousel
                            id="productsCarousel"
                            ref="productsCarousel"
                            v-model="imgCarousel"
                            :interval="7000"
                            controls
                            indicators
                            @sliding-start="onSlideStart"
                            @sliding-end="onSlideEnd"
                            class="carousel-experiences-min"
                          >
                            <template #prev>
                              <button @click="prev">Prev</button>
                            </template>

                            <b-carousel-slide
                              v-for="(image, i) in gallery"
                              :key="i"
                            >
                              <template #img>
                                <LazyImage
                                  :src="image.url || noImage"
                                  :alt="`${image.caption}`"
                                  imgClasses="img-carousel-min curp"
                                  @click="openBox(i)"
                                />
                              </template>
                              <span
                                v-if="image.caption"
                                class="title-carousel"
                                >{{ image.title }}</span
                              >
                            </b-carousel-slide>
                          </b-carousel>

                          <LightBox
                            v-if="showLightbox"
                            :media="images"
                            :showLightBox="showLightbox"
                            :startAt="currentImageIndex"
                          />
                        </div>
                        <div v-else>
                          <LazyImage
                            :src="noImage"
                            alt="noimage"
                            imgClasses="img-carousel-min curp"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-12 col-lg-12 col-md-6 col-sm-12 col-12 mt-4"
                      >
                        <div class="card">
                          <div
                            class="grid-container"
                            v-if="product.destination"
                          >
                            <div
                              class="grid-item"
                              v-if="product.categories.length > 0"
                            >
                              <strong class="b-color">Category:</strong>
                            </div>
                            <div
                              class="grid-item"
                              v-if="product.categories.length > 0"
                            >
                              {{ getCategories(product.categories) }}
                            </div>
                            <div class="grid-item">
                              <strong class="b-color">Supplier:</strong>
                            </div>
                            <div class="grid-item">
                              {{ product.destination.contact.name }}
                            </div>

                            <div class="grid-item">
                              <strong class="b-color">Destination:</strong>
                            </div>
                            <div class="grid-item">
                              {{ product.location }}
                            </div>

                            <div
                              class="grid-item"
                              v-if="showDurationByOption(product.options)"
                            >
                              <strong class="b-color">Duration:</strong>
                            </div>
                            <div
                              class="grid-item"
                              v-if="showDurationByOption(product.options)"
                            >
                              {{ getDurationByOption(product.options) }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import LightBox from "vue-image-lightbox";
import "vue-image-lightbox/dist/vue-image-lightbox.min.css";
import { goBack } from "../../../../../helpers/commons.helpers";
import { VentrataAPI } from "../../../../../core/api";
export default {
  name: "ExperienceVentrata",
  data() {
    return {
      images: [],
      showLightbox: false,
      currentImageIndex: 0,
      imgCarousel: 0,
      product: {
        title: "",
        code: "",
        country: "US",
        subtitle: "",
        description: "",
        shortDescription: "",
        pickupPoints: [],
        defaultCurrency: "",
        availableCurrencies: [""],
        inclusions: [],
        exclusions: [],
        highlights: [],
        redemptionInstructions: null,
        bookingTerms: null,
        cancellationPolicy: null,
        importantInformation: [],
        destination: null,
        faqs: [],
        coverImageUrl: "",
        bannerImageUrl: "",
        videoUrl: "",
        galleryImages: [],
        bannerImages: [],
        cancellationPolicy: null,
        meetingPoint:
          "Redeem this voucher at 2724 Taylor St, San Francisco, CA, 94133. You can call us at 415-440-8687 if you have any questions.",
        meetingPointCoordinates: [38.8951, -77.0364],
        options: [],
        location: "",
        categories: []
      },
      option: null,
      gallery: [],
      itinerary: [],
      pickupAvailable: false,
      pickupPoints: [],
      pickupRequired: false,
      noImage: require("rhomtrip_assets/src/img/no-image-available.png"),
      pricing: null,
      providerId: null
    };
  },
  async created() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },
      {
        text: "Ventrata Experiences",
        to: "/experiences/ventrata"
      },
      {
        text: "Experience Details",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.productId = this.$route.params.uuid;
    this.providerId = this.$route.query.providerId;
    await this.getProductDetails(this.productId, this.providerId);
    this.getAllProductImages(this.product);
  },
  methods: {
    async getProductDetails(productId, providerId) {
      try {
        this.setLoad(true);
        let { data } = await VentrataAPI.getProduct(
          productId,
          true,
          providerId
        );
        let product = data;
        this.product.title = product.title || product.internalName;
        this.product.code = product.code;
        this.product.country = product.country;
        this.product.subtitle = product.subtitle;
        this.product.description = product.description;
        this.product.shortDescription = product.shortDescription;
        this.product.defaultCurrency = product.defaultCurrency;
        this.product.availableCurrencies = product.availableCurrencies;
        this.product.inclusions = product.inclusions;
        this.product.exclusions = product.exclusions;
        this.product.highlights = product.highlights;
        this.product.redemptionInstructions = product.redemptionInstructions;
        this.product.bookingTerms = product.bookingTerms;
        this.product.cancellationPolicy = product.cancellationPolicy;

        this.product.videoUrl = product.videoUrl;
        this.product.galleryImages = product.galleryImages;
        this.product.bannerImages = product.bannerImages;

        this.product.faqs = product.faqs;
        this.product.coverImageUrl = product.coverImageUrl;
        this.product.bannerImageUrl = product.bannerImageUrl;

        this.product.destination = product.destination;
        this.product.location = product.location;
        this.product.categories = product.categories;
        this.product.pickupPoints = product.pickupPoints;

        this.product.options = product.options;

        this.option = this.getDefaultOption(this.product.options);
        this.pricing = this.getPricingFromByUnits(
          this.option.units,
          this.product.defaultCurrency
        );
        this.itinerary = this.option.itinerary ? this.option.itinerary : [];
        this.pickupAvailable = this.option
          ? this.option.pickupAvailable
          : false;
        this.pickupPoints = this.option ? this.option.pickupPoints : [];
        this.pickupRequired = this.option ? this.option.pickupRequired : false;
        this.setLoad(false);
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could not be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    getDefaultOption(options = []) {
      let [option] = options;
      return option;
    },
    getCategories(categories = []) {
      return categories.map(category => category.name).join(", ");
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    openBox(index) {
      this.currentImageIndex = index;
      this.images = this.getNewPicturesFormat(this.gallery);
      this.showLightbox = false;
      this.$nextTick(() => {
        this.showLightbox = true;
      });
    },
    getNewPicturesFormat(images) {
      return images.map((image, index) => {
        return {
          thumb: image.url,
          src: image.url
        };
      });
    },
    goToPreviousPage() {
      goBack(this);
    },
    async getAllProductImages(product) {
      let images = [];

      if (product.coverImageUrl) {
        images.push({
          url: product.coverImageUrl,
          title: "Cover",
          caption: ""
        });
      }

      if (product.galleryImages && product.galleryImages.length > 0) {
        images.push(...product.galleryImages);
      }

      if (product.bannerImageUrl) {
        images.push({
          url: product.bannerImageUrl,
          title: "Banner",
          caption: ""
        });
      }

      if (product.bannerImages && product.bannerImages.length > 0) {
        images.push(...product.bannerImages);
      }

      this.gallery = images;
    },
    goToNewReservation(productId, providerId) {
      this.$router.push({
        path: "/reservations/new",
        query: { productId: productId, providerId: providerId }
      });
    },
    emptyAnswersCount() {
      return this.product.faqs.filter(
        faq => !faq.answer || faq.answer.trim() === ""
      ).length;
    },
    showFaqBoxes() {
      return this.emptyAnswersCount <= 1;
    },
    getCurrenSymbolByCurrency(currency) {
      if (currency === "USD") {
        return "$";
      } else if (currency === "EUR") {
        return "€";
      } else if (currency === "GBP") {
        return "£";
      }
    },
    getPriceByCurrencyPrecision(price, currencyPrecision) {
      let total = price / Math.pow(10, currencyPrecision);
      return total.toFixed(2);
    },
    getPricingFromByUnits(units = [], defaultCurrency) {
      let [unit] = units;
      return unit ? this.getPricingFromByUnit(unit, defaultCurrency) : null;
    },
    getPricingFromByUnit(unit, defaultCurrency) {
      try {
        if (unit) {
          let pricing = unit.pricingFrom.find(
            pricing => pricing.currency === defaultCurrency
          );
          return pricing ? pricing : null;
        } else {
          return null;
        }
      } catch (error) {
        return null;
      }
    },
    getDurationByOption(options = []) {
      let [option] = options;
      return option ? option.duration : "";
    },
    showDurationByOption(options = []) {
      let [option] = options;
      if (option) {
        return option.duration ? true : false;
      }
      return false;
    },
    ...mapActions(["getSesion"]),
    ...mapMutations(["setLoad", "setItemsBread"])
  },
  components: {
    LightBox
  },
  computed: {
    ...mapGetters(["sesion"])
  }
};
</script>
